// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../config/styles';

const styles = ({
  mainContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 10,
  },
  mainPaper: {
    width: 800,
    margin: 15,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    borderRadius: 20,
    zIndex: 10,
  },
});

export default styles;
